import AdminUsersPage from "./pages/AdminUsersPage";
import AdminRolesPage from "./pages/AdminRolesPage";
import UserProfilePage from "./pages/UserProfilePage";
import AdminRoleRequestsPage from "./pages/AdminRoleRequestsPage";

import AktienNewsDashboard from "views/AktienNewsDashboard";
import TradingViewDashboard from "views/TradingViewDashboard";

import PeopleIcon from "@material-ui/icons/People";
import PersonIcon from "@material-ui/icons/Person";
import SecurityIcon from "@material-ui/icons/Security";
import DashboardIcon from "@material-ui/icons/Dashboard";
import VerifiedUser from "@material-ui/icons/VerifiedUser";

import ImpressumPage from "views/legal/ImpressumPage";
import DatenschutzPage from "views/legal/DatenschutzPage";
import NutzungsbedingungenPage from "views/legal/NutzungsbedingungenPage";
import DisclaimerPage from "views/legal/DisclaimerPage";
import RisikohinweisPage from "views/legal/RisikohinweisPage";
import KiHinweisPage from "views/legal/KiHinweisPage";
import HelpPage from "views/legal/HelpPage";

import { ROLES } from "auth/roles";

var dashRoutes = [
    {
        path: "/hilfe",
        name: "Hilfe",
        component: HelpPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/impressum",
        name: "Impressum",
        component: ImpressumPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/datenschutz",
        name: "Datenschutz",
        component: DatenschutzPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/nutzungsbedingungen",
        name: "Nutzungsbedingungen",
        component: NutzungsbedingungenPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/disclaimer",
        name: "Disclaimer",
        component: DisclaimerPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/risikohinweis",
        name: "Risikohinweis",
        component: RisikohinweisPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/ki-hinweis",
        name: "KI-Hinweis",
        component: KiHinweisPage,
        layout: "/admin",
        invisible: true,
        guestAllowed: true
    },
    {
        path: "/profile",
        name: "Profil",
        icon: PersonIcon,
        component: UserProfilePage,
        layout: "/admin"
    },
    {
        path: "/users",
        name: "Benutzer",
        icon: PeopleIcon,
        component: AdminUsersPage,
        layout: "/admin",
        roles: [ROLES.ADMIN_USERS_MANAGE]
    },
    {
        path: "/roles",
        name: "Rollen",
        icon: SecurityIcon,
        component: AdminRolesPage,
        layout: "/admin",
        roles: [ROLES.ADMIN_ROLES_MANAGE]
    },
    {
        path: "/role-requests",
        name: "Rollen-Anträge",
        icon: VerifiedUser,
        component: AdminRoleRequestsPage,
        layout: "/admin",
        roles: [ROLES.ADMIN_USERS_MANAGE]
    },
    {
        path: "/aktiennews",
        name: "Aktien-News",
        icon: DashboardIcon,
        component: AktienNewsDashboard,
        layout: "/admin",
        roles: [ROLES.NEWS_VIEW],
        guestAllowed: true
    },
    {
        path: "/tradingview",
        name: "Trading View",
        icon: DashboardIcon,
        component: TradingViewDashboard,
        layout: "/admin",
        requestableRole: ROLES.TRADING_VIEW
    }
];

export default dashRoutes;